export enum StepStatesEnum {
    open = 'open', // untouched state
    selected = 'selected', // selected state
    inProgress = 'inProgress', // touched with errors but review step hasn't been touched
    completed = 'completed', // completed state
    error = 'error', // has errors
    warning = 'warning', // has warnings
}
